import { JSX } from "react";
import EmblaSlider from "../../lib/Embla-slider";
import { TSlideWidith } from "../../lib/Embla-slider/EmblaSliderContainer";

interface Props {
  width: number;
  spacing: number;
  isFilterDrawer?: boolean;
  children: JSX.Element[];
  sliderMaxWidth?: number;
  className?: string;
}

const OptionsCarousel: React.FC<Props> = ({
  width,
  spacing,
  isFilterDrawer = false,
  children,
  sliderMaxWidth,
  className,
}) => {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: sliderMaxWidth ? sliderMaxWidth : "100%",
        marginInlineEnd: isFilterDrawer ? -16 : -24,
      }}
      className={className}
    >
      <EmblaSlider>
        <EmblaSlider.EmblaSliderViewport>
          <EmblaSlider.EmblaSliderContainer
            extraClassName="options-carousel"
            gap={spacing}
            slides={[
              ...(children as Array<JSX.Element>)?.map((child, key) => ({
                component: (
                  <div key={key} style={{ width: width }}>
                    {child}
                  </div>
                ),
                width: "auto" as TSlideWidith,
              })),
            ]}
          />
        </EmblaSlider.EmblaSliderViewport>
      </EmblaSlider>
    </div>
  );
};

export default OptionsCarousel;
